<template>
  <div class="achievement-widget" @click="trigger">
    <div class="achievement-badge" :class="badgeClass">
      {{ $store.state.achievement.count }}
    </div>
  </div>
</template>

<script>
import EventBus from "@/imports/event-bus";

export default {
  data() {
    return {};
  },

  computed: {
    badgeClass() {
      if (this.$store.state.achievement.currentTier) {
        return `achievement-${this.$store.state.achievement.currentTier.title}`;
      }

      return "";
    },
  },

  methods: {
    trigger() {
      if (this.$store.state.achievement.currentTier.title !== "starter") {
        EventBus.$emit("new-achievement");
      }
    },
  },
};
</script>
